// Services d'accès Worker pour la gestion des images ImageKit
// Centralise les appels HTTP vers le Worker Cloudflare

const WORKER_BASE = 'https://onyros-api.atelier-davai.workers.dev';

export interface DeleteImageParams {
  fileId?: string;
  filePath?: string;
  url?: string;
}

export async function deleteImage(params: DeleteImageParams): Promise<{ success: boolean }>{
  const res = await fetch(`${WORKER_BASE}/api/delete-image`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params)
  });
  const json = await res.json();
  if (!res.ok || !json?.success) {
    throw new Error(json?.error || `Suppression échouée (${res.status})`);
  }
  return { success: true };
}

export interface UploadResponse {
  success: boolean;
  url: string;
  filePath?: string;
  name?: string;
  data?: any;
}

export async function uploadBase64ToImageKit(base64: string, fileName: string, folder?: string): Promise<UploadResponse> {
  const formData = new FormData();
  formData.append('file', base64);
  formData.append('fileName', fileName);
  if (folder) formData.append('folder', folder);

  const res = await fetch(`${WORKER_BASE}/api/upload-image`, {
    method: 'POST',
    body: formData
  });
  const json = await res.json();
  if (!res.ok || !json?.url) {
    throw new Error(json?.error || `Upload échoué (${res.status})`);
  }
  return json as UploadResponse;
}
